<template>
  <div
    ref="containerCart"
    class="product-cart"
  >
    <div
      v-for="(bundle, index) in bundles"
      :key="index"
      class="product"
    >
      <div
        ref="imageCart"
        class="product__image"
      >
        <img
          width="80"
          :src="imageBundleOrProductLoading(bundle)"
          alt="package"
          loading="lazy"
        />
      </div>
      <div class="product__details">
        <div class="d-flex">
          <AmTypography
            data-test="product_name"
            wrapperElement="p"
            :style="returnDynamicStyle"
            class="product__details__name text--dark-2 mr-1"
            :text="bundle.name"
            typography-style="l6"
          />
          <a
            v-if="checkStringLength(bundle.name) && $mq === 'desktop'"
            class="mt-3 pointer"
            @click="showModalDescription(bundle)"
          >
            (...)
          </a>
        </div>
        <div class="d-flex w-100 justify-content-between justify-mobile">
          <div class="product__quantity">
            <AmQuantity
              v-if="allowMultipleSales"
              v-model="bundle.qty"
              data-test="product_quantity"
              :min="1"
              :max="1000"
              :disabledRemove="enableAndDisabledProductQuantity"
              :disabledAdd="enableAndDisabledProductQuantity"
              :readonly="enableAndDisabledProductQuantity"
              @change="updateQuantityBundle(bundle)"
            />
            <AmTypography
              v-show="showRemoveBundle(index) && $mq === 'mobile'"
              data-test="product_remove"
              typography-style="l6"
              textColor="error"
            >
              <template>
                <AmSkeleton
                  v-if="loadingCart"
                  class="product__price__skeleton"
                  AmType="text"
                  AmTextWidth="40"
                  AmTextBorder
                  AmTextHeight="sm"
                  :AmTextGroupLimit="3"
                />
                <div
                  v-else
                  v-show="!enableAndDisabledProductQuantity"
                  class="product__remove"
                  @click="removeBundle(bundle)"
                >
                  {{ $t('remove') }}
                </div>
              </template>
            </AmTypography>
          </div>
          <div class="product__price">
            <AmTypography
              v-show="showRemoveBundle(index) && $mq !== 'mobile'"
              data-test="product_remove"
              typography-style="l6"
              textColor="error"
            >
              <template>
                <AmSkeleton
                  v-if="loadingCart"
                  class="product__price__skeleton"
                  AmType="text"
                  AmTextWidth="40"
                  AmTextBorder
                  AmTextHeight="sm"
                  :AmTextGroupLimit="3"
                />
                <div
                  v-else
                  v-show="!enableAndDisabledProductQuantity"
                  class="product__remove"
                  @click="removeBundle(bundle)"
                >
                  {{ $t('remove') }}
                </div>
              </template>
            </AmTypography>
            <div v-if="loadingCart">
              <AmSkeleton
                class="product__price__skeleton"
                AmType="text"
                AmTextWidth="40"
                AmTextBorder
                AmTextHeight="sm"
                :AmTextGroupLimit="3"
              />
            </div>
            <AmTypography
              v-else
              data-test="product_price"
              class="text--dark-2"
              typography-style="l5"
            >
              <template>
                <div>
                  {{ bundle.price | currency({ codeCurrency: getCurrencyCode }) }}
                </div>
              </template>
            </AmTypography>
          </div>
        </div>
      </div>
    </div>
    <AmModal
      v-if="showModalBundleName"
      :title="$t('containerRigth.product')"
      @close="showModalBundleName = false"
    >
      <template>
        <div class="d-flex">
          <div class="mr-3">
            <img
              width="100"
              :src="imageBundleOrProductLoading(activeBundle)"
              alt="package"
              loading="lazy"
            />
          </div>
          <AmTypography
            data-test="product_name"
            wrapperElement="p"
            class="text--dark-2 text-break mobile-font"
            :text="activeBundle.name"
            typography-style="l6"
          />
        </div>
      </template>
    </AmModal>
  </div>
</template>

<script>
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import themeMixin from '@/components/mixins/themeMixin'
import loadImageBundlesMixin from '@/components/mixins/loadImageBundlesMixin'
import { mapState, mapActions, mapGetters } from 'vuex'
import AmQuantity from '@/components/molecules/AmQuantity.vue'

export default {
  name: 'ProductCart',
  components: {
    AmQuantity,
  },
  mixins: [currencyFilterMixin, themeMixin, loadImageBundlesMixin],
  props: {
    value: {
      type: Array,
    },
    isRightPanelShown: {
      type: Boolean,
      default: false,
    },
    allowMultipleSales: {
      default: true,
    },
  },
  data() {
    return {
      activeBundle: {},
      showModalBundleName: false,
      addProductQuantity: 0,
      containerWidth: 0,
      imageWidth: 0,
    }
  },
  computed: {
    ...mapState('Checkout', {
      enableAndDisabledProductQuantity: (state) => state.disebleOrEnableAddRemove,
      loadingCart: (state) => state.cartLoading,
    }),
    ...mapGetters('Cart', ['getCurrencyCode']),
    bundles() {
      return this.value
    },
    returnDynamicStyle() {
      return window.screen.width > 1199
        ? `width: calc(${this.containerWidth}px - ${this.imageWidth}px - 90px);`
        : null
    },
  },
  watch: {
    bundles: {
      deep: true,
      immediate: true,
      handler() {
        this.handleResize()
      },
    },
    isRightPanelShown: {
      deep: true,
      immediate: true,
      handler() {
        this.handleResize()
      },
    },
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('Checkout', ['updateBundle', 'removeBundle']),
    showModalDescription(bundle) {
      this.activeBundle = bundle
      this.showModalBundleName = true
    },
    handleResize() {
      if (this.$refs.containerCart && this.$refs.imageCart) {
        this.containerWidth = this.$refs.containerCart.clientWidth
        this.imageWidth = this.$refs.imageCart[0].clientWidth
      }
    },
    checkStringLength(string) {
      if (string) {
        return string.length >= 30
      }
      return false
    },
    updateQuantityBundle(bundle) {
      this.updateBundle(bundle)
    },
    postRemoveBundle(bundle) {
      this.removeBundle(bundle)
    },
    showRemoveBundle(index) {
      return index > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.product-cart {
  @include tablet {
    padding: 0 24px;
  }
  @include mobile {
    padding: 0 24px;
  }
  .mobile-font {
    @include mobile {
      font-size: 13px;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .justify-mobile {
    @include mobile {
      flex-direction: column-reverse;
      align-items: flex-start;
    }
  }
  .product {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
    background: $light-60;
    @include tablet {
      border: 1px solid $light-60;
      border-radius: 4px;
      background: transparent;
    }
    @include mobile {
      border: 1px solid $light-60;
      border-radius: 4px;
      background: transparent;
    }
    &__image {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 80px;
      margin: {
        left: 20px;
        right: 20px;
      }
      img {
        max-height: 80px;
        object-fit: contain;
      }
    }

    &__details {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      max-height: 50%;
      &__name ::v-deep p {
        overflow: hidden;
        white-space: nowrap;
        max-width: 100%;
        margin: 20px 0 15px 0;
        @include tablet {
          white-space: break-spaces;
        }
        @include mobile {
          white-space: break-spaces;
        }
      }

      &__skeleton {
        width: 129px;
        margin-bottom: 7px;
        ::v-deep {
          .b-skeleton {
            background-color: $light-80 !important;
          }
          .b-skeleton-animate-wave::after {
            background: linear-gradient(90deg, transparent, $white, transparent);
          }
        }
      }
    }

    &__price {
      text-align: right;
      margin: {
        left: 10px;
        right: 20px;
      }

      &__skeleton {
        width: 70px;
        margin-bottom: 7px;
        ::v-deep {
          .b-skeleton {
            background-color: $light-80 !important;
          }
          .b-skeleton-animate-wave::after {
            background: linear-gradient(90deg, transparent, $white, transparent);
          }
        }
      }

      @include mobile {
        margin: 10px 0px;
        display: flex;
        flex-direction: row-reverse;
      }
    }

    &__quantity {
      @include mobile {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }

    &__remove {
      cursor: pointer;
      text-align: right;
      margin: 0 15px 13px 0;
    }
  }

  @include mobile {
    &__product {
      background: $white;
      border: solid 1px $light-40;
      border-radius: 4px;
      box-sizing: border-box;
      margin: 0 16px 0 16px;
      padding: 0 12px 0 12px;
    }
  }

  @include tablet {
    &__product {
      background: $white;
      border: solid 1px $light-40;
      border-radius: 4px;
      box-sizing: border-box;
      margin: 0 16px 0 16px;
      padding: 0 12px 0 12px;
      justify-content: space-between;
      &__details {
        flex: 1;
        padding: 0 16px 0 16px;
      }
    }
  }
}
</style>
